export default {
  // Snap override of the core default: --color-bordered is white in this
  // theme, so the stock border is invisible on white surfaces. Use a real
  // gray outline in the normal state; focus keeps the primary ring.
  default: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text_secondary mb-1",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input:
      "rounded-full w-full text-text bg-canvas focus:bg-canvas border border-bordered focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent px-3 py-2",
    input_with_icon: "pl-10",
    textarea:
      "w-full px-3 py-2 bg-canvas focus:bg-canvas border border-bordered rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },

  //Used in search bar, user details, etc. -------------------------------
  snap: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "w-full h-[40px] lg:h-[48px] rounded-full text-sm md:text-base text-text placeholder-text_secondary bg-paper focus:bg-paper border border-bordered px-4 py-2 focus:outline-none focus:ring-1 focus:ring-primary focus:border-none",
    input_with_icon: "pl-14",
    textarea: "w-full focus:transparent placeholder-text_secondary border border-none rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-none",
  },

  snap_compact: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "w-full h-[40px] rounded-full text-sm text-text placeholder-text_secondary/80 bg-neutral focus:bg-neutral px-4 py-2 focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-none",
    input_with_icon: "pl-12",
    textarea: "w-full rounded-xl text-sm text-text placeholder-text_secondary/80 bg-neutral focus:bg-neutral px-4 py-2.5 focus:outline-none focus:ring-1 focus:ring-primary/50 focus:border-none",
  },

  // Ported from aqua-web-app — used by the Store checkout flow overrides
  aqua_input: {
    root: "text-text",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-5 flex items-center pointer-events-none text-primary",
    input: "h-[40px] md:h-[44px] lg:h-[48px] rounded-full w-full px-4 py-2 text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] text-text_secondary bg-theme_white focus:bg-theme_white border border-bordered focus:outline-none focus:ring-2 focus:ring-primary focus:border-none",
    input_with_icon: "pl-14",
    textarea: "w-full px-3 py-2 focus:transparent border border-none rounded-md focus:outline-none focus:ring-1 focus:border-none",
  },

  aqua: {
    root: "relative w-full items-center",
    label: "block text-sm font-medium text-text mb-2",
    required: "text-error",
    input_wrapper: "relative flex items-center",
    icon_wrapper: "absolute left-3 flex items-center pointer-events-none",
    input: "rounded-[12px] w-full text-text bg-theme_white focus:bg-theme_white border border-bordered focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent px-4 py-3 text-[14px] md:text-[16px]",
    input_with_icon: "pl-10",
    textarea: "w-full px-4 py-3 bg-theme_white focus:bg-theme_white border border-bordered rounded-[12px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-[14px] md:text-[16px]",
    error_text: "mt-1 text-sm text-error",
    error_state: "border-error",
  },

}
